module.exports = __webpack_public_path__ + "static/menu_x86_act6.8c27d054.png";